// extracted by mini-css-extract-plugin
export default {"bodyText":"StaffSelectWorkspace_bodyText__a+-aF","container":"StaffSelectWorkspace_container__3KpVQ"};